module.exports = __webpack_public_path__ + "img/w67.d94f9b8e.svg";